/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Serializer for the incoming PlannerInitialConsultationCheckView POST request data.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface PlannerInitialConsultationCheckRequest { 
    patientId: string;
}
export const PlannerInitialConsultationCheckRequest_patientId_Validators: ValidatorFn[] =
    [  Validators.required, ];


